/*       */
import styled from 'styled-components';
import Block from '../Block/Block';

const InputWrapper = styled(Block)`
    padding: 0.5rem 0;
`;

export default InputWrapper;
